import { useContext, useMemo } from "react";

import { useGetProperty } from "../api/properties/hooks";
import { PropertyScopeContext } from "../contexts/PropertyContext";
import { DEFAULT_TIMEZONE } from "@tether-web-portal/constants/timezone";

/**
 * IANA timezone for metrics: the current property when on a property page (from React Query),
 * otherwise the NZ platform default.
 */
export function useTimezone(): string {
  const propertyScope = useContext(PropertyScopeContext);
  const { propertyId } = propertyScope || {};

  const { property } = useGetProperty(propertyId ?? "", {
    enabled: Boolean(propertyId),
  });

  const timezone = useMemo((): string => {
    if (propertyId && property?.timezone) {
      return property.timezone;
    }
    return DEFAULT_TIMEZONE;
  }, [propertyId, property]);

  return timezone;
}
